import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import ApiDatabase from '../../../../../server';
import { useState } from 'react';
import { toast } from 'react-toastify';

const ModalPayslipDelete = () => {
  const { toggle } = useModal();
  const { modalData } = UseContext();
  const token = localStorage.getItem('xsrfToken');

  const payslips = modalData?.payslips || [];
  const year = modalData?.year || '';
  const month = modalData?.month || '';
  const isBulk = payslips.length > 1;

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = () => {
    setIsLoading(true);
    ApiDatabase.deletePayslips(
      {
        token,
        year,
        month,
        id_temp_worker_bestt: payslips.map((p) => p.id_temp_worker_bestt),
      },
      (data) => {
        setIsLoading(false);
        toast.success(
          `${data.successes?.length || 0} fiche(s) de paie supprimée(s).`
        );
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Erreur');
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Supprimer {isBulk ? `${payslips.length} fiches de paie` : 'une fiche de paie'}
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-3 text-sm">
          <p className="text-red-600 font-medium">
            Cette action est irréversible. Les fichiers seront supprimés de S3
            et de la base de données.
          </p>
          {isBulk ? (
            <div className="max-h-[300px] overflow-y-auto border rounded">
              <table className="w-full text-sm">
                <thead className="bg-gray-50 sticky top-0">
                  <tr>
                    <th className="p-2 text-left">ID BeSTT</th>
                    <th className="p-2 text-left">Nom / Prénom</th>
                    <th className="p-2 text-right">Montant</th>
                  </tr>
                </thead>
                <tbody>
                  {payslips.map((p) => (
                    <tr
                      key={p.id_temp_worker_bestt}
                      className="border-t border-gray-100"
                    >
                      <td className="p-2">{p.id_temp_worker_bestt}</td>
                      <td className="p-2">
                        {p.lastname} {p.firstname}
                      </td>
                      <td className="p-2 text-right">
                        {p.amount ? `${Number(p.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            payslips[0] && (
              <div className="flex flex-col gap-1">
                <div>
                  <strong>ID :</strong> {payslips[0].id_temp_worker_bestt}
                </div>
                <div>
                  <strong>Nom :</strong> {payslips[0].lastname}{' '}
                  {payslips[0].firstname}
                </div>
                <div>
                  <strong>Période :</strong> {year}/{month}
                </div>
                <div>
                  <strong>Montant :</strong>{' '}
                  {payslips[0].amount
                    ? `${Number(payslips[0].amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
                    : '-'}
                </div>
              </div>
            )
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex gap-2">
          <Button onClick={toggle} size="LG" color="SECONDARY">
            Annuler
          </Button>
          <Button
            onClick={handleConfirm}
            size="LG"
            color="WARNING"
            disabled={isLoading}
          >
            {isLoading ? 'Suppression...' : 'Confirmer la suppression'}
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};

export default ModalPayslipDelete;
